import SectionHeader from "@/components/SectionHeader";
import { TrendingUp, Building2, ShieldCheck, DollarSign, Home as HomeIcon } from "lucide-react";

const priorities = [
  {
    icon: TrendingUp,
    title: "Managing Growth Responsibly",
    body: "South Lebanon is growing — and how we manage that growth will define our future. Linda will continue to champion thoughtful zoning, strong development standards, and infrastructure planning that keeps pace with our community.",
  },
  {
    icon: Building2,
    title: "Investing in Infrastructure",
    body: "Roads, water, drainage, and public spaces are the backbone of a strong town. Linda will keep delivering long-overdue improvements without overspending or shifting costs onto homeowners.",
  },
  {
    icon: ShieldCheck,
    title: "Supporting Public Safety",
    body: "Every family deserves to feel safe. Linda will continue to fully fund our first responders, invest in modern equipment and training, and strengthen partnerships with local law enforcement.",
  },
  {
    icon: DollarSign,
    title: "Maintaining Fiscal Responsibility",
    body: "Balanced budgets. Honest planning. No property tax hikes. Linda's record proves South Lebanon can deliver more — without burdening residents.",
  },
  {
    icon: HomeIcon,
    title: "Preserving Community Character",
    body: "The small-town character of South Lebanon is what brought many of us here — and it's worth protecting. Linda will defend the parks, traditions, and neighborhoods that make this place feel like home.",
  },
];

export default function Priorities() {
  return (
    <div className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeader
          eyebrow="Priorities"
          title="Protecting What Makes South Lebanon Special."
          intro="Five clear commitments shaping the next four years — and the future of our community."
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="priorities-list">
          {priorities.map(({ icon: Icon, title, body }, i) => (
            <article
              key={title}
              data-testid="priority-item"
              className={`bg-card border border-border p-8 relative ${i === 4 ? "md:col-span-2" : ""}`}
            >
              <div className="flex items-start gap-5">
                <div className="shrink-0">
                  <div className="text-xs uppercase tracking-[0.2em] text-accent font-bold mb-2">
                    No. 0{i + 1}
                  </div>
                  <div className="w-14 h-14 bg-primary text-primary-foreground flex items-center justify-center">
                    <Icon size={26} />
                  </div>
                </div>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-primary leading-tight mb-3">
                    {title}
                  </h3>
                  <p className="text-foreground/85 leading-relaxed">{body}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
